<template>
	<el-dialog title="富文本消息" :visible.sync="visible" width="800px" :close-on-click-modal="false"
		@close="onClose" class="rich-text-editor-dialog" :modal-append-to-body="true">
		<div class="rich-text-container">
			<!-- 工具栏 -->
			<div class="editor-toolbar">
				<Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode" />
			</div>

			<!-- 编辑器 -->
			<div class="editor-content">
				<Editor :defaultConfig="editorConfig" :mode="mode" v-model="valueHtml"
					@onCreated="handleCreated" @onChange="handleChange" style="height: 350px" />
			</div>

			<!-- 底部操作栏 -->
			<div class="editor-footer">
				<span class="char-count">{{ charCount }} 字</span>
				<div class="footer-actions">
					<el-button size="small" @click="close">取消</el-button>
					<el-button type="success" size="small" icon="el-icon-s-promotion" @click="sendRichText"
						:disabled="!canSend" :loading="uploading">
						发送
					</el-button>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { DomEditor } from '@wangeditor/editor'

export default {
	name: "RichTextEditor",
	components: { Editor, Toolbar },
	data() {
		return {
			visible: false,
			editorRef: null,
			valueHtml: '<p></p>',
			mode: 'default',
			uploading: false,
			toolbarConfig: {
				// 工具栏配置
				excludeKeys: [
					'headerSelect',
					'blockquote',
					'|',
					'group-video',
					'insertTable',
					'codeBlock',
					'fullScreen'
				]
			},
			editorConfig: {
				placeholder: '请输入消息内容，支持图文混排...',
				MENU_CONF: {
					// 图片上传配置
					uploadImage: {
						customUpload: this.customUploadImage
					},
					// 图片插入配置
					insertImage: {
						onInsertedImage: (imageNode) => {
							console.log('inserted image', imageNode)
						}
					}
				}
			}
		};
	},
	computed: {
		canSend() {
			const text = this.valueHtml.replace(/<[^>]*>/g, '').trim()
			return text.length > 0 || this.valueHtml.includes('<img')
		},
		charCount() {
			const text = this.valueHtml.replace(/<[^>]*>/g, '')
			return text.length
		}
	},
	methods: {
		open() {
			this.visible = true
			this.valueHtml = '<p></p>'
			this.$nextTick(() => {
				if (this.editorRef) {
					this.editorRef.focus()
				}
			})
		},
		close() {
			this.visible = false
		},
		onClose() {
			this.valueHtml = '<p></p>'
		},
		handleCreated(editor) {
			this.editorRef = editor
			// 设置编辑器聚焦
			this.$nextTick(() => {
				editor.focus()
			})
		},
		handleChange(editor) {
			this.valueHtml = editor.getHtml()
		},
		// 自定义图片上传
		async customUploadImage(file, insertFn) {
			// 检查文件大小（最大5MB）
			if (file.size > 5 * 1024 * 1024) {
				this.$message.warning("图片大小不能超过5MB")
				return
			}

			try {
				const formData = new FormData()
				formData.append('file', file)

				const response = await this.$http.post("/image/upload?isPermanent=false", formData, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})

				// 插入图片到编辑器
				insertFn(response.originUrl, response.originUrl, response.thumbUrl || response.originUrl)
			} catch (error) {
				console.error('图片上传失败:', error)
				this.$message.error('图片上传失败，请重试')
			}
		},
		async sendRichText() {
			if (!this.canSend) {
				this.$message.warning("请输入内容")
				return
			}

			this.uploading = true
			const loading = this.$loading({
				lock: true,
				text: '正在发送...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			try {
				// 获取编辑器原始HTML内容
				const editor = this.editorRef
				const html = editor.getHtml()

				// 构建富文本消息内容 - 直接发送原始HTML
				const richTextContent = {
					html: html
				}

				// 发送消息
				this.$emit('send', richTextContent)
				this.close()
			} catch (error) {
				console.error('发送富文本消息失败:', error)
				this.$message.error('发送失败，请重试')
			} finally {
				loading.close()
				this.uploading = false
			}
		}
	},
	beforeDestroy() {
		const editor = this.editorRef
		if (editor == null) return
		editor.destroy()
	}
}
</script>

<style lang="scss">
.rich-text-editor-dialog {
	.el-dialog__body {
		padding: 20px;
	}

	.rich-text-container {
		.editor-toolbar {
			border-bottom: 1px solid #e8e8e8;
		}

		.editor-content {
			border: 1px solid #e8e8e8;
			border-top: none;
			border-bottom: none;

			.w-e-text-container {
				background-color: #fff !important;

				* {
					text-align: left !important;
				}

				.w-e-text {
					text-align: left !important;

					* {
						text-align: left !important;
					}
				}

				.w-e-edit {
					text-align: left !important;

					* {
						text-align: left !important;
					}
				}

				[data-slate-editor] {
					text-align: left !important;

					* {
						text-align: left !important;
					}
				}
			}
		}

		.editor-footer {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 15px 0 0;
			border-top: 1px solid #e8e8e8;

			.char-count {
				color: #909399;
				font-size: 13px;
			}

			.footer-actions {
				display: flex;
				gap: 10px;
			}
		}
	}
}
</style>